<template>
  <div id="walkabouts">
    <h1>WEAVING THE FLEECE - FEEDING THE MOLESKINE - DOING THINGS</h1>
    <div class="content-wrapper">
      <div>revisiting the banks</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LatestWalkabouts'
}
</script>

<style lang='scss'>
#walkabouts {
  height: 100%;
  .content-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
}
</style>
